import {HeroSlider} from './components/HeroSlider/HeroSlider';
HeroSlider()
